var exports = {
  "$": "x93eb46d8--e341a4--input-container--with-tags",
};

module.exports = exports;
